<div class="dialog">
  <div class="content">
    <ng-container>
      <div class="msg error">{{isExpired ? 'The request timed out' : errorMsg}}</div>
    </ng-container>
  </div>
</div>